meedy.factory('meedy.userService', ['$q', '$http', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig',
    function ($q, $http, baseService, objectHelper, config) {

        function UserService() {

            this.getDataPage = function (criteria) {
                return baseService.post(config.API_URL + '/users/dataPage', criteria).then(
                    function (successResponse) {
                        var dataPage = objectHelper.translateObject(successResponse, DataPageVO);
                        dataPage.data = objectHelper.translateArray(dataPage.data, UserMeedyVO);

                        return dataPage;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.usersAvailableForLoggedUser = function (criteria) {
                return baseService.post(config.API_URL + '/users/usersAvailableForLoggedUser', criteria).then(
                    function (successResponse) {
                        var dataPage = objectHelper.translateObject(successResponse, DataPageVO);
                        dataPage.data = objectHelper.translateArray(dataPage.data, UserMeedyVO);

                        return dataPage;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getById = function (id) {
                return baseService.get(config.API_URL + '/users/' + id).then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, UserMeedyVO);
                        return data;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.save = function (user) {
                return baseService.post(config.API_URL + '/users/save', user).then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, UserMeedyVO);
                        return data;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.create = function (user) {
                return baseService.post(config.API_URL + '/users/create', user).then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, UserMeedyVO);
                        return data;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.update = function (user) {
                return baseService.post(config.API_URL + '/users/update', user).then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, UserMeedyVO);
                        return data;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.updatePartnerUser = function (user) {
                return baseService.post(config.API_URL + '/users/updatePartnerUser', user).then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, UserMeedyVO);
                        return data;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.deleteAll = function (users) {
                return baseService.post(config.API_URL + '/users/deleteAll', users).then(
                    function (successResponse) {
                        return successResponse;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.delete = function (userId) {
                return baseService.delete(config.API_URL + '/users/' + userId).then(
                    function (successResponse) {
                        return successResponse;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.updateStatus = function (user) {
                return baseService.post(config.API_URL + '/users/updateStatus', user).then(
                    function (successResponse) {
                        return successResponse;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.accept = function (firstLoginUser) {
                return baseService.post(config.API_URL + '/users/accept', firstLoginUser).then(
                    function (successResponse) {
                        return successResponse;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.changePassword = function (oldPassword, newPassword) {
                var changePasswordWrapper = {
                    oldPassword : oldPassword,
                    newPassword : newPassword
                };

                return baseService.post(config.API_URL + '/users/changePassword', changePasswordWrapper).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, UserMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.confirmCreation = function (password, token) {
                var confirmCreation = {
                    'password' : password
                };

                return baseService.post(config.API_URL + '/users/confirmCreation/' + token, confirmCreation).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.validateUserPartnerToken = function (token) {
                return baseService.get(config.API_URL + '/users/validateUserPartnerToken/' + token).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, UserRegistrationMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.remindPassword = function (mail) {
                var requestConfig = {
                    headers: {
                        'login': mail
                    }
                };

                // return $http(req).then(function (successResponse) {
                return baseService.post(config.API_URL + '/users/remindPassword', null, requestConfig).then(function (successResponse) {
                    return successResponse;
                }, function (errorResponse) {
                    return $q.reject(errorResponse);
                });
            };

            this.getLoggedUser = function () {
                return baseService.get(config.API_URL + '/users/loggedUserData').then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, UserMeedyVO);
                        return data;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.passwordExpired = function () {
                return baseService.get(config.API_URL + '/users/passwordExpired').then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, PasswordExpiredMeedyVO);
                        return data;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.confirmPhysician = function (uuid) {
                return baseService.post(config.API_URL + '/users/physician/confirm/' + uuid).then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, PasswordExpiredMeedyVO);
                        return data;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

	    	this.getRoleList = function(criteria) {
	            return baseService.post(config.API_URL + '/users/getRoleList', criteria).then(
	                function(successResponse) {
	                	var data = objectHelper.translateArray(successResponse, RoleMeedyVO);
	                    return data;
	                },
	                function(errorResponse) {
	                    return $q.reject(errorResponse);
	                }
	            );
	        };

	    	this.getMyData = function() {
	            return baseService.get(config.API_URL + '/users/getMyDataAbc').then(
	                function(successResponse) {
	                	var data = objectHelper.translateObject(successResponse, MyDataWrapperMeedyVO);
	                    return data;
	                },
	                function(errorResponse) {
	                    return $q.reject(errorResponse);
	                }
	            );
	        };

	    	this.updateMyData = function(myDataWrapper) {
	            return baseService.post(config.API_URL + '/users/updateMyData', myDataWrapper).then(
	                function(successResponse) {
	                	var data = objectHelper.translateObject(successResponse, MyDataWrapperMeedyVO);
	                    return data;
	                },
	                function(errorResponse) {
	                    return $q.reject(errorResponse);
	                }
	            );
	        };

            this.uploadOfficePicture = function(picture, resourceId) {
                return baseService.upload(config.API_URL + '/resources/picture/' + resourceId, picture).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.uploadDoctorPicture = function(picture, resourceDetailsId) {
                return baseService.upload(config.API_URL + '/resourceDetails/picture/' + resourceDetailsId, picture).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.deleteOfficePicture = function(resourceId) {
                return baseService.delete(config.API_URL + '/resources/picture/reset/' + resourceId).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

	    	this.sendActivationLink = function(idUser) {
	            return baseService.get(config.API_URL + '/users/' +  idUser + '/sendActivationLink').then(
	                function(successResponse) {
	                    return successResponse;
	                },
	                function(errorResponse) {
	                    return $q.reject(errorResponse);
	                }
	            );
	        };

	    	this.pwzExistence = function(pwz) {
	            return baseService.get(config.API_URL + '/users/pwzExistence/' + pwz).then(
	                function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, ExistWrapperMeedyVO);
	                    return successResponse;
	                },
	                function(errorResponse) {
	                    return $q.reject(errorResponse);
	                }
	            );
	        };

            this.alabIntegrationAvailable = function() {
                return baseService.post(config.API_URL + '/users/alabIntegrationAvailable').then(
                    function(data) {
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getCurrentUserTawkToken = function () {
                return baseService.get(config.API_URL + '/users/tawkToken').then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, TawkToKeyVO);
                        return data;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

        }

        return new UserService();
    }
]);
